import DeckContextMenu from './DeckContextMenu.jsx'

export default function DeckCard({ deck, transparent = false, onViewQuiz, onManageThemes, onEdit, onDelete, onDuplicate, readOnly = false }) {
  const n = deck.sous_themes?.length ?? 0
  const q = deck.questions?.length ?? 0

  return (
    <div
      className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-200 cursor-pointer"
      onClick={onViewQuiz}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onViewQuiz?.()}
    >
      <div className="relative bg-gray-900/80 backdrop-blur-sm border border-white/10 p-4 flex flex-col gap-2">
        <div className="absolute top-3 right-3" onClick={e => e.stopPropagation()}>
          <DeckContextMenu
            deckId={deck.id}
            onViewQuiz={onViewQuiz}
            onManageThemes={onManageThemes}
            onEdit={onEdit}
            onDelete={onDelete}
            onDuplicate={onDuplicate}
            readOnly={readOnly}
          />
        </div>

        <h2 className="text-white font-semibold text-base leading-tight line-clamp-2 pr-8">{deck.titre}</h2>

        <div className="flex flex-wrap gap-1">
          {deck.education_level && deck.education_level !== 'Non applicable' && (
            <span className="bg-white/20 text-white text-xs px-2 py-0.5 rounded-full backdrop-blur-sm">
              {deck.education_level}
            </span>
          )}
          {deck.matiere && (
            <span className="bg-purple-500/20 text-purple-300 text-xs px-2 py-0.5 rounded-full backdrop-blur-sm">
              {deck.matiere}
            </span>
          )}
          {deck.visibility === 'public' && (
            <span className="bg-white/20 text-white text-xs px-2 py-0.5 rounded-full backdrop-blur-sm">
              🌐 Public
            </span>
          )}
        </div>

        <div className="flex flex-wrap gap-1 min-h-[22px]">
          {deck.keywords?.map(kw => (
            <span key={kw} className="bg-black/20 text-white/90 text-xs px-1.5 py-0.5 rounded-full">
              #{kw}
            </span>
          ))}
        </div>

        <div className="text-xs text-white/40 mt-1">
          {q} question{q !== 1 ? 's' : ''} · {n} sous-thème{n !== 1 ? 's' : ''}
        </div>
      </div>
    </div>
  )
}
